var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCutlery = function SvgCutlery(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.626 1.25c-.225 0-.375.15-.375.375v6.188c0 1.462-1.238 2.662-2.775 2.662H17.4v-8.85c0-.225-.15-.375-.375-.375s-.375.15-.375.375v8.85h-.075c-1.538 0-2.775-1.2-2.775-2.662V1.625c0-.225-.15-.375-.375-.375s-.375.15-.375.375v6.188c0 1.875 1.575 3.412 3.525 3.412h.075v12.15c0 .225.15.375.375.375s.375-.15.375-.375v-12.15h.075c1.95 0 3.525-1.537 3.525-3.412V1.625c0-.225-.15-.375-.375-.375ZM7.537 1.362H5.963c-1.2 0-2.213.975-2.213 2.175L3 14.9a.34.34 0 0 0 .112.262.405.405 0 0 0 .263.113h3.787v8.1c0 .225.15.375.375.375.226 0 .375-.15.375-.375V1.737a.403.403 0 0 0-.375-.375Zm-3.75 13.163L4.5 3.537c0-.787.638-1.425 1.463-1.425h1.2v12.413H3.786Z",
    fill: "#D18357",
    stroke: "#D18357",
    strokeWidth: 0.5
  })));
};
export default SvgCutlery;